import React, { useEffect } from 'react';
import { useNotification } from '../hooks/useNotification';
import { Button } from 'antd';
import { GenericReportingDropdowns } from "../containers/GenericReportingDropdowns";

const NotificationHookTest = () => {
  const { notifications, notificationHistory, addNotification } =
    useNotification();

  useEffect(() => {
    console.log("notifications");
    console.log(notifications);
    console.log("notificationHistory");
    console.log(notificationHistory);
  }, [notifications, notificationHistory]);

  return (
    <div>
      <GenericReportingDropdowns />
      <h1>Notification Hook Test</h1>
      <Button
        onClick={() =>
          addNotification({
            title: "Title",
            message: "Message",
            type: "success",
          })
        }
      >
        Add Notification Success
      </Button>
      <Button
        onClick={() =>
          addNotification({
            title: "Title",
            message: "Message",
            type: "info",
          })
        }
      >
        Add Notification Info
      </Button>
      <Button
        onClick={() =>
          addNotification({
            title: "Title",
            message: "Message",
            type: "warning",
          })
        }
      >
        Add Notification Warning
      </Button>
      <Button
        onClick={() =>
          addNotification({
            title: "Title",
            message: "Message",
            type: "error",
          })
        }
      >
        Add Notification Error
      </Button>
    </div>
  );
};

export default NotificationHookTest;